/**
 * /offline — editorial fallback when the SPA boots offline.
 *
 * The service worker's `navigateFallback: '/offline'` routes every offline
 * navigation here. The page is intentionally minimal: a serif heading, two
 * lines of editorial copy, and a link back home. No fonts, no images, no
 * data dependencies — it must render from the precache without network.
 *
 * Per UX §3.14 + AC-098.
 */
import { Link } from 'react-router-dom';

export default function OfflineRoute() {
  return (
    <section
      className="mx-auto max-w-md w-full pt-20 pb-12 px-6 text-center"
      data-testid="offline-route"
    >
      <p className="font-sans text-xs uppercase tracking-[0.18em] text-ink-500 mb-3">
        No connection
      </p>
      <h1 className="font-serif text-4xl md:text-5xl text-ink-900 leading-tight mb-6">
        You&apos;re offline.
      </h1>
      <p className="font-serif italic text-base text-ink-700 leading-relaxed mb-8">
        Some of your journal is still readable. Reconnect to capture or edit.
      </p>
      <Link
        to="/home"
        className="inline-block font-sans text-xs uppercase tracking-[0.18em] text-accent border-b border-accent pb-1 hover:text-ink-900 hover:border-ink-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-accent"
      >
        Back to your journal
      </Link>
    </section>
  );
}
